module.exports = __webpack_public_path__ + "img/BG1.48c17031.png";